<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.91272 10.4943C3.13966 10.4943 3.32427 10.3097 3.32427 10.0828V3.41219C3.32427 3.08766 3.58884 2.82427 3.91219 2.82427H10.5828C10.8097 2.82427 10.9943 2.63966 10.9943 2.41272C10.9943 2.18578 10.8097 2 10.5828 2H3.91219C3.13378 2 2.5 2.63378 2.5 3.41219V10.0828C2.5 10.3097 2.68461 10.4943 2.91272 10.4943Z"
      :fill="iconColor"
    />
    <path
      d="M10.5828 21.1769H3.91219C3.58766 21.1769 3.32427 20.9123 3.32427 20.5878V13.9172C3.32427 13.6903 3.13966 13.5057 2.91272 13.5057C2.68578 13.5057 2.5 13.6891 2.5 13.9172V20.5878C2.5 21.3662 3.13378 21.9988 3.91219 21.9988H10.5828C10.8097 21.9988 10.9943 21.8154 10.9943 21.5873C10.9943 21.3592 10.8097 21.1769 10.5828 21.1769Z"
      :fill="iconColor"
    />
    <path
      d="M21.0866 2H14.4172C14.1903 2 14.0057 2.18461 14.0057 2.41155C14.0057 2.63849 14.1903 2.82309 14.4172 2.82309H21.0866C21.4112 2.82309 21.6757 3.08766 21.6757 3.41102V10.0816C21.6757 10.3085 21.8592 10.4931 22.0873 10.4931C22.3154 10.4931 22.4988 10.3085 22.4988 10.0816V3.41219C22.4976 2.63378 21.865 2 21.0866 2Z"
      :fill="iconColor"
    />
    <path
      d="M22.0861 13.5057C21.8592 13.5057 21.6746 13.6903 21.6746 13.9172V20.5878C21.6746 20.9123 21.41 21.1769 21.0855 21.1769H14.416C14.1891 21.1769 14.0045 21.3603 14.0045 21.5885C14.0045 21.8166 14.1891 22 14.416 22H21.0855C21.8639 22 22.4965 21.3674 22.4965 20.589V13.9184C22.4976 13.6891 22.3142 13.5057 22.0861 13.5057Z"
      :fill="iconColor"
    />
    <path
      d="M16.4585 12.411C16.6854 12.411 16.87 12.2263 16.87 11.9994C16.87 11.7725 16.6866 11.5879 16.4585 11.5879H12.911V8.03916C12.911 7.81222 12.7263 7.62761 12.4994 7.62761C12.2725 7.62761 12.0879 7.81222 12.0879 8.03916V11.5879H8.53916C8.31222 11.5879 8.12761 11.7725 8.12761 11.9994C8.12761 12.2263 8.31222 12.411 8.53916 12.411H12.0879V15.9585C12.0879 16.1854 12.2725 16.37 12.4994 16.37C12.7263 16.37 12.911 16.1866 12.911 15.9585V12.411H16.4585Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAddZone",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
